import { styled } from "styled-components";

export const Result = styled.tr`
  border-radius: 12px;
  width: 100%;
  padding: 12px;
  overflow: clip;

  > td {
    line-height: 24px;
    padding: 12px 24px;

    &:first-of-type {
      color: ${({ theme }) => theme.colors.default[600]};
      font-weight: 550;
      border-radius: 12px 0 0 12px;
    }

    &:last-of-type {
      border-radius: 0 12px 12px 0;
    }
  }

  &:nth-of-type(odd) {
    td {
      background: ${({ theme }) => theme.colors.default[50]};
    }
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    > td {
      vertical-align: bottom;
      padding: 12px;
      max-width: 0;

      &:nth-of-type(2) {
        > p {
          width: 100%;
          color: ${({ theme }) => theme.colors.default[600]};
          font-weight: 550;
          border-radius: 12px 0 0 12px;
          text-align: center;
          padding: 12px 0;
        }
      }
    }
  }
`;

export const Price = styled.div`
  color: ${({ theme }) => theme.colors.default[900]};
  font-weight: 700;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export const Promo = styled.div`
  color: ${({ theme }) => theme.colors.primary.default};
  display: flex;
  align-items: center;
  gap: 4px;

  > svg {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const Strike = styled.span`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.default[600]};
`;
